import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import OfficialPage from '../OfficialPage';

import './VipBenefits.less';

export default class VipBenefits extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      title: '会员权益'
    },
    slideData: [], // 存的是会员卡的logo
    currentIndex: 0,
    startX: 0,
    moveX: 0,
    cardListData: [], // 会员卡列表信息
    currentCard: {}, // 当前会员卡信息
    requesting: false,
    currentComboIndex: 0, // 当前选中的优惠套餐的下标
    price: 0, // 价格
    cardId: '', // 会员卡id
    isPaidCard: '', // 是否为付费会员卡
    isRenew: '', // 是否为续费会员
    isNeedCollect: 0, // 是否需要收集会员信息
    userPaidVipCard: {}, // 用户付费卡
    userVipCard: {}, // 用户的规则卡
    specialNote: '', // 特别说明
    isVipBenefitDay: 0, // 是否存在会员日
    isUserDiyLogo: false, // 是否为用户自定义logo
    loading: true, // 首屏是否在加载
    franchiseeId: '' // 子店id
  }

  constructor(props) {
    super(props);
    document.title = '会员权益';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let id = options.id || ''
    let isPaidCard = options.is_paid_card || ''
    let isRenew = options.is_renew || ''
    let franchiseeId = options.franchisee || ''
    let cardtype = options.cardtype || ''
    this.setData({
      cardId: id,
      isPaidCard: isPaidCard,
      isRenew: isRenew,
      franchiseeId: franchiseeId,
      cardtype: cardtype
    })
    this.getAllVipCardInfo()
    this.getCollectUserinfoConfig()
  }

  touchStart = e => {
    let startX = e.changedTouches[0].clientX
    this.setData({
      startX: startX
    })
  }
  touchMove = e => {
    let endX = e.changedTouches[0].clientX
    let moveX = endX - this.data.startX // moveX：右移为负数，左移为正数，
    let currentIndex = this.data.currentIndex
    let len = this.data.slideData.length
    if (
      (currentIndex <= 1 && moveX >= 0) ||
      (currentIndex >= len - 2 && moveX <= 0)
    ) {
      return
    }
    this.setData({
      moveX: moveX
    })
    if (Math.abs(moveX) >= 250) {
      this.setData({
        startX: this.data.startX + moveX,
        moveX: 0
      })
      if (moveX > 0 && this.data.currentIndex > 0) {
        this.setData({
          startX: this.data.startX + moveX,
          currentIndex: this.data.currentIndex - 1,
          moveX: 0
        })
      } else if (moveX <= 0 && this.data.currentIndex < len) {
        this.setData({
          startX: this.data.startX + moveX,
          currentIndex: this.data.currentIndex + 1,
          moveX: 0
        })
      }
    }
    this.setCurrentCard()
  }
  touchEnd = e => {
    let endX = e.changedTouches[0].clientX
    let moveX = endX - this.data.startX
    let currentIndex = this.data.currentIndex
    let len = this.data.slideData.length
    if (
      (currentIndex < 1 && moveX > 0) ||
      (currentIndex > len - 2 && moveX < 0) // ||
    ) {
      return
    }
    this.setData({
      moveX: moveX
    })
    if (moveX === 0) {
      if (endX > 250 || endX < 125) {
        this.setData({
          currentIndex:
            endX > 250
              ? this.data.currentIndex + 1
              : endX < 125
              ? this.data.currentIndex - 1
              : '',
          moveX: 0
        })
      }
    } else {
      this.setData({
        currentIndex:
          moveX > 0 ? this.data.currentIndex - 1 : this.data.currentIndex + 1,
        moveX: 0
      })
    }
    this.setCurrentCard()
  }
  getAllVipCardInfo = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=appVipCard/getUserAccountSurvey',
      method: 'post',
      data: {
        sub_shop_app_id: _this.data.franchiseeId,
        card_type: _this.data.cardtype
      },
      hideLoading: false,
      success: function(res) {
        let data = res.data.all_vip_card
        let slideData = []
        let isPaidCard = _this.data.isPaidCard
        let cardId = _this.data.cardId
        let cardListData = []
        let userPaidVipCard = res.data.user_paid_vip_card
          ? res.data.user_paid_vip_card
          : {}
        let userVipCard = res.data.user_vip_card ? res.data.user_vip_card : {}
        data.map(item => {
          if (item.condition_type == 0 && (!isPaidCard || cardId)) {
            if (
              item.id === userVipCard.vip_id ||
              item.id === userPaidVipCard.vip_id
            ) {
              slideData.push(item.logo)
            } else {
              slideData.push(item.pre_logo || item.logo)
            }
            cardListData.push(item)
          } else if (item.condition_type == 1 && (!isPaidCard || cardId)) {
            if (
              item.id === userVipCard.vip_id ||
              item.id === userPaidVipCard.vip_id
            ) {
              slideData.push(item.logo)
            } else {
              slideData.push(item.pre_logo || item.logo)
            }
            cardListData.push(item)
          } else if (item.condition_type == 2) {
            if (
              item.id === userVipCard.vip_id ||
              item.id === userPaidVipCard.vip_id
            ) {
              slideData.push(item.logo)
            } else {
              slideData.push(item.pre_logo || item.logo)
            }
            cardListData.push(item)
          }
        })
        slideData.forEach((item, index) => {
          if (item.indexOf('/vip-card/') !== -1) {
            // 如果为自定义logo则不在logo上显示卡名称
            cardListData[index].is_show_title = 1
          } else {
            cardListData[index].is_show_title = 0
          }
        })
        _this.setData({
          cardListData: cardListData,
          slideData: slideData,
          userPaidVipCard: userPaidVipCard,
          userVipCard: userVipCard,
          isVipBenefitDay: res.data.is_vip_benefit_day
        })
        if (_this.data.cardId) {
          _this.setCurrentIndex(_this.data.cardId)
        }
        _this.setCurrentCard()
      },
      complete: function(res) {
        _this.setData({
          loading: false
        })
      }
    })
  }
  setCurrentIndex = id => {
    let allCardData = this.data.cardListData
    let currentIndex = 0
    allCardData.forEach((item, index) => {
      if (this.data.isPaidCard == 1 || this.data.isRenew == 1) {
        if (item.condition_type == 2 && item.id == id) {
          currentIndex = index
        }
      } else {
        if (
          (item.condition_type == 0 || item.condition_type == 1) &&
          item.id == id
        ) {
          currentIndex = index
        }
      }
    })
    this.setData({
      currentIndex: currentIndex
    })
  }
  setCurrentCard = () => {
    let info = this.data.cardListData[this.data.currentIndex]
    let price = 0
    let specialNoteArr = []
    let isUserDiyLogo = false
    if (!info) {
      return
    }
    if (info.condition_type == 0) {
      // condition_text：获取条件的文字说明
      info.condition_text = ['无门槛']
    } else if (info.condition_type == 1) {
      info.condition_text = []
      if (info.trade_count !== '-1') {
        info.condition_text.push(`累计交易成功${info.trade_count}笔`)
      }
      if (info.consume_count !== '-1') {
        let text = ''
        if (info.condition_text.length) {
          text += '或'
        }
        text += `累计消费金额${info.consume_count}元`
        info.condition_text.push(text)
      }
      if (info.integral_count !== '-1') {
        let text = ''
        if (info.condition_text.length) {
          text += '或'
        }
        text += `累计积分达到${info.integral_count}分`
        info.condition_text.push(text)
      }
    } else if (info.condition_type == 2) {
      info.condition_text = ['付费购买']
    }
    if (info.combo && !Array.isArray(info.combo)) {
      // combo：优惠套餐
      info.combo = JSON.parse(info.combo)
    }
    if (info.combo) {
      info.combo = info.combo.map(item => {
        if (item.price) {
          item.price = Number(item.price).toFixed(2)
        }
        return item
      })
    }
    if (info.price) {
      price = info.price
    }
    if (
      info.coupon_list &&
      Array.isArray(info.coupon_list) &&
      info.coupon_list.length
    ) {
      info.coupon_list = info.coupon_list.map(coupon => {
        coupon.name =
          coupon.type === '0'
            ? '满减券'
            : coupon.type === '1'
            ? '打折券'
            : coupon.type === '2'
              ? '代金券'
              : coupon.type === '3'
                ? '兑换券'
                : coupon.type === '4'
                  ? '储值券'
                  : coupon.type === '5'
                    ? '通用券'
                    : coupon.type === '6'
                      ? '次数券'
                      : ''
        return coupon
      })
    }
    if (
      info.birthday_coupon_list &&
      Array.isArray(info.birthday_coupon_list) &&
      info.birthday_coupon_list.length
    ) {
      info.birthday_coupon_list = info.birthday_coupon_list.map(coupon => {
        coupon.name =
          coupon.type === '0'
            ? '满减券'
            : coupon.type === '1'
            ? '打折券'
            : coupon.type === '2'
              ? '代金券'
              : coupon.type === '3'
                ? '兑换券'
                : coupon.type === '4'
                  ? '储值券'
                  : coupon.type === '5'
                    ? '通用券'
                    : coupon.type === '6'
                      ? '次数券'
                      : ''
        return coupon
      })
    }
    if (info.coupon_list && info.coupon_list.length) {
      specialNoteArr.push('优惠券')
    }
    if (info.balance && info.balance != 0) {
      specialNoteArr.push('储值')
    }
    if (info.integral && info.integral != 0) {
      specialNoteArr.push('积分')
    }
    if (
      this.data.slideData[this.data.currentIndex].indexOf('/vip-card/') === -1
    ) {
      isUserDiyLogo = true
    }
    this.setData({
      currentCard: info,
      currentComboIndex: 0,
      price: price,
      specialNote:
        specialNoteArr.join('、') + '在付费会员卡有效期限内每月赠送一次',
      isUserDiyLogo: isUserDiyLogo
    })
  }
  addPaidCardOrder = () => {
    let _this = this
    this.setData({
      requesting: true
    })
    app.sendRequest({
      url: '/index.php?r=appVipCard/addPaidVipCardOrder',
      method: 'post',
      data: {
        data_id: _this.data.currentCard.id,
        price: _this.data.price,
        sub_shop_app_id: _this.data.franchiseeId
      },
      hideLoading: false,
      success: function(res) {
        let orderId = res.data
        _this.payOrder(orderId)
      }
    })
  }
  getCollectUserinfoConfig = () => {
    let _this = this
    let userInfo = app.getUserInfo()
    app.sendRequest({
      url: '/index.php?r=appVipCard/getCollectUserinfoConfig',
      method: 'post',
      hideLoading: true,
      data: {
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function(res) {
        _this.setData({
          isNeedCollect: res.data.need_collect_info
            ? res.data.need_collect_info
            : 0
        })
      }
    })
  }
  payOrder = orderId => {
    let _this = this
    function paySuccess() {
      if (_this.data.isNeedCollect) {
        app.turnToPage(
          '/pages/userCenter/userCenter?id=' + _this.data.currentCard.id
        )
      } else {
        app.turnToPage('/pages/userCenterComponentPage/userCenterComponentPage')
      }
    }
    function payFail() {
      app.turnToPage('/pages/userCenterComponentPage/userCenterComponentPage')
    }
    if (this.data.price == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function(res) {
          paySuccess()
        },
        fail: function() {
          payFail()
        },
        complete: function() {
          _this.setData({
            requesting: false
          })
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function(res) {
    //     let param = res.data
    //     param.orderId = orderId
    //     param.goodsType = 8
    //     param.success = paySuccess
    //     param.fail = payFail
    //     _this.wxPay(param)
    //   },
    //   complete: function() {
    //     _this.setData({
    //       requesting: false
    //     })
    //   }
    // })
    let backurl = '/userCenterComponentPage';
    if (_this.data.isNeedCollect) {
      backurl = '/userCenter?id=' + _this.data.currentCard.id;
    }
    app.goPay({
      orderId: orderId,
      successUrl: backurl,
      failUrl: '/userCenterComponentPage',
      cancel: payFail
    });
    _this.setData({
      requesting: false
    })
  }
  // wxPay = param => {
  //   let _this = this
  //   Taro.requestPayment({
  //     timeStamp: param.timeStamp,
  //     nonceStr: param.nonceStr,
  //     package: param.package,
  //     signType: param.signType,
  //     paySign: param.paySign,
  //     success: function(res) {
  //       _this.wxPaySuccess(param)
  //       typeof param.success === 'function' && param.success()
  //     },
  //     fail: function(res) {
  //       if (res.errMsg === 'requestPayment:fail cancel') {
  //         _this.showModal({
  //           content: '支付已取消',
  //           complete: function() {
  //             typeof param.fail === 'function' && param.fail()
  //           }
  //         })
  //         return
  //       }
  //       if (res.errMsg === 'requestPayment:fail') {
  //         res.errMsg = '支付失败'
  //       }
  //       _this.showModal({
  //         content: res.errMsg
  //       })
  //       _this.wxPayFail(param, res.errMsg)
  //       typeof param.fail === 'function' && param.fail()
  //     }
  //   })
  // }
  // wxPaySuccess = param => {
  //   let orderId = param.orderId,
  //     formId = param.package.substr(10),
  //     _this = this
  //   app.sendRequest({
  //     hideLoading: true,
  //     url: '/index.php?r=AppShop/SendXcxOrderCompleteMsg',
  //     data: {
  //       formId: formId,
  //       order_id: orderId
  //     }
  //   })
  //   if (
  //     this.isNeedCollect == 0 &&
  //     this.data.userPaidVipCard.vip_id != this.data.currentCard.id
  //   ) {
  //     app.sendRequest({
  //       hideLoading: true,
  //       url: '/index.php?r=appVipCard/sendRecvVipCardMsg',
  //       data: {
  //         formId: formId,
  //         vip_id: _this.data.currentCard.id,
  //         sub_shop_app_id: _this.data.franchiseeId
  //       }
  //     })
  //   }
  // }
  // wxPayFail = (param, errMsg) => {
  //   let orderId = param.orderId,
  //     formId = param.package.substr(10)
  //   app.sendRequest({
  //     hideLoading: true,
  //     url: '/index.php?r=AppShop/SendXcxOrderCompleteMsg',
  //     data: {
  //       formId: formId,
  //       t_num: 'AT0010',
  //       order_id: orderId,
  //       fail_reason: errMsg
  //     }
  //   })
  // }
  selectCombo = e => {
    let index = +e.currentTarget.dataset.index
    let currentCard = this.data.currentCard
    let price =
      index == 0
        ? currentCard.price
        : currentCard.combo[index - 1].price
        ? currentCard.combo[index - 1].price
        : currentCard.combo[index - 1].original_price
    this.setData({
      currentComboIndex: index,
      price: price
    })
  }
  gotoMemberDay = () => {
    app.turnToPage('/eCommerce/pages/memberDay/memberDay')
  }

  render() {
    const {
      cardListData,
      currentCard,
      isVipBenefitDay,
      currentIndex,
      moveX,
      slideData,
      userVipCard,
      userPaidVipCard,
      loading,
      isUserDiyLogo,
      currentComboIndex,
      specialNote,
      requesting
    } = this.state
    return (
      <div className="official-page vip-benefits">
        <TopNav title="会员权益"/>
        <div
          className="content"
          style={convertLineStyleData(
            'background: ' +
            (cardListData.length
              ? 'url(https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/vip-card/more-power-bg.jpg)'
              : '#3e3935')
          )}
        >
          <div className="slide-wrapper">
            {!!isVipBenefitDay && (
              <div className="member-day-block" onClick={this.gotoMemberDay}>
                <div
                  className="member-day"
                  style={convertLineStyleData(
                    'background-color: ' +
                    (currentCard.style_config &&
                    currentCard.style_config.vip_benefit_day
                      ? currentCard.style_config.vip_benefit_day
                      : '#FF7100')
                  )}
                >
                  会员日
                </div>
              </div>
            )}
            {slideData.map((item, index) => {
              return (
                <div
                  className={
                    'slide-item ' + (index === currentIndex ? 'active' : '')
                  }
                  style={convertLineStyleData(
                    'left: ' +
                    ((index + 1 - currentIndex) * 250 + moveX) +
                    'rpx'
                  )}
                  key={index}
                  onTouchStart={this.touchStart}
                  onTouchMove={this.touchMove}
                  onTouchEnd={this.touchEnd}
                >
                  <div className="image-block">
                    <img src={item} />
                      {cardListData[index].is_show_title && (
                        <div className="card-name">
                          <span>{cardListData[index].title}</span>
                        </div>
                      )}
                  </div>
                </div>
            )
            })}
            {(userVipCard.vip_id === currentCard.id ||
              userPaidVipCard.vip_id === currentCard.id) &&
            !!cardListData.length && (
              <img
                className="star-img"
                src="https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/vip-card/vip-benefit-star.svg"
              />
            )}
            </div>
            {cardListData.length === 0 && !loading && (
              <div className="empty-data">暂无会员卡</div>
            )}
            {!!(cardListData.length) && (
              <div className="detail">
              {!!(isUserDiyLogo) && (
                <div className="detail-item">
                  <div className="top-block">
                    <div className="name">名称</div>
                    <div
                      className="condition"
                      style={convertLineStyleData(
                        'color: ' +
                        (currentCard.style_config &&
                        currentCard.style_config.condition
                          ? currentCard.style_config.condition
                          : '#FF7100')
                      )}
                    >
                      {currentCard.title}
                    </div>
                  </div>
                </div>
              )}
              <div className="detail-item">
                <div className="top-block">
                  <div className="name">状态</div>
                  <div
                  className="condition"
                  style={convertLineStyleData(
                  'color: ' +
                  (currentCard.style_config &&
                  currentCard.style_config.condition
                    ? currentCard.style_config.condition
                    : '#FF7100')
                )}
                  >
                  {userPaidVipCard.vip_id == currentCard.id ||
                  userVipCard.vip_id == currentCard.id
                    ? '已领取'
                    : '未领取'}
                  </div>
                </div>
              </div>
              <div className="detail-item">
              <div className="top-block">
                <div className="name">获取条件</div>
                  <div
                  className="condition"
                  style={convertLineStyleData(
                  'color: ' +
                  (currentCard.style_config &&
                  currentCard.style_config.condition
                    ? currentCard.style_config.condition
                    : '#FF7100')
                )}
                  >
                  {Array.isArray(currentCard.condition_text) && currentCard.condition_text.map((item, index) => {
                    return (
                      <div
                        className="condition-item"
                        key={index}
                      >
                        {item}
                      </div>
                    )
                  })}
                  </div>
                </div>
              </div>
              {currentCard.condition_type == 2 && (
                <div className="detail-item detail-benefit">
                  <div className="top-block m-b-30">
                    <div className="name">优惠套餐</div>
                  </div>
                  <ScrollView scroll-x="true" className="benefits">
                    <div
                      className={
                        'benefit-item ' +
                        (currentComboIndex == 0 ? 'active' : '')
                      }
                      data-index="0"
                      onClick={this.selectCombo}
                    >
                      <div
                        className="icon-block"
                        style={convertLineStyleData(
                          'border-color: ' +
                          (currentComboIndex != 0
                            ? '#d5d5d5'
                            : currentCard.style_config &&
                            currentCard.style_config.condition
                              ? currentCard.style_config.condition
                              : '#ffebdc')
                        )}
                      >
                        {currentComboIndex == 0 && (
                          <label
                            className="ico-moon icon-gou"
                            style={convertLineStyleData(
                              'color: ' +
                              (currentCard.style_config &&
                              currentCard.style_config.condition
                                ? currentCard.style_config.condition
                                : '#FF7100')
                            )}
                          ></label>
                        )}
                      </div>
                      <div className="content-block">
                        <div className="count">1个月</div>
                        <div
                          className="price"
                          style={convertLineStyleData(
                            'color: ' +
                            (currentCard.style_config &&
                            currentCard.style_config.condition
                              ? currentCard.style_config.condition
                              : '#FF7100')
                          )}
                        >
                          ¥<label>{currentCard.price}</label>
                        </div>
                      </div>
                    </div>
                    {currentCard.combo && currentCard.combo.map((item, index) => {
                      return (
                        <div
                          className={
                            'benefit-item ' +
                            (currentComboIndex === index + 1 ? 'active' : '')
                          }
                          data-index={index + 1}
                          key={index}
                          onClick={this.selectCombo}
                        >
                          <div
                            className="icon-block"
                            style={convertLineStyleData(
                              'border-color: ' +
                              (currentComboIndex !== index + 1
                                ? '#d5d5d5'
                                : currentCard.style_config &&
                                currentCard.style_config.condition
                                  ? currentCard.style_config.condition
                                  : '#ffebdc')
                            )}
                          >
                            {currentComboIndex === index + 1 && (
                              <label
                                className="ico-moon icon-gou"
                                style={convertLineStyleData(
                                  'color: ' +
                                  (currentCard.style_config &&
                                  currentCard.style_config.condition
                                    ? currentCard.style_config.condition
                                    : '#FF7100')
                                )}
                              ></label>
                            )}
                          </div>
                          <div className="content-block">
                            <div className="count">{item.num + '个月'}</div>
                            <div
                              className="price"
                              style={convertLineStyleData(
                                'color: ' +
                                (currentCard.style_config &&
                                currentCard.style_config.condition
                                  ? currentCard.style_config.condition
                                  : '#FF7100')
                              )}
                            >
                              ¥
                              <label>
                                {item.price ? item.price : item.original_price}
                              </label>
                            </div>
                            <div className="cut-price">
                              ¥<label>{item.original_price}</label>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </ScrollView>
                </div>
              )}
              <div className="detail-item">
                <div className="top-block m-b-30">
                  <div className="name">会员权益</div>
                </div>
                <div className="about-wrapper">
                  {currentCard.discount && currentCard.discount != 0 && (
                    <div className="about-item">
                      <div className="name">折扣</div>
                      <div className="about">
                        {'所有商品一律' + currentCard.discount + '折'}
                      </div>
                    </div>
                  )}
                  {!!(currentCard.coupon_list && currentCard.coupon_list.length) && (
                    <div className="about-item">
                      <div className="name">优惠券</div>
                      <div className="about">
                        {currentCard.coupon_list.map((item, index) => {
                          return (
                            <div key={index}>
                              {item.name +
                              '-' +
                              item.title +
                              ' -' +
                              item.num +
                              '张'}
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )}
                  {currentCard.integral && currentCard.integral != 0 && (
                    <div className="about-item">
                      <div className="name">积分</div>
                      <div className="about">
                        {'开卡赠送' + currentCard.integral + '积分'}
                      </div>
                    </div>
                  )}
                  {currentCard.balance && currentCard.balance != 0 && (
                    <div className="about-item">
                      <div className="name">储值</div>
                      <div className="about">
                        {'开卡赠送储值' + currentCard.balance + '元'}
                      </div>
                    </div>
                  )}
                  {currentCard.is_free_postage &&
                  currentCard.is_free_postage !== '0' && (
                    <div className="about-item">
                      <div className="name">包邮</div>
                      <div className="about">所有商品包邮</div>
                    </div>
                  )}
                  {!!(currentCard.birthday_coupon_list &&
                  currentCard.birthday_coupon_list.length) && (
                    <div className="about-item">
                      <div className="name">生日优惠</div>
                      <div className="about">
                        {currentCard.birthday_coupon_list.map(
                          (item, index) => {
                            return (
                              <div key={index}>
                                {item.name + '-' + item.title}
                              </div>
                            )
                          }
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {(currentCard.phone ||
                currentCard.description ||
                currentCard.condition_type == 2) && (
                <div className="detail-item">
                  <div className="about-wrapper">
                    {specialNote !== '' && currentCard.condition_type == 2 && (
                      <div className="about-item">
                        <div className="name">特别说明</div>
                        <div className="about">
                          {specialNote}
                          <div>付费卡购买成功后不支持退款</div>
                        </div>
                      </div>
                    )}
                    {currentCard.phone && (
                      <div className="about-item">
                        <div className="name">联系</div>
                        <div className="about">{currentCard.phone}</div>
                      </div>
                    )}
                    {currentCard.description && (
                      <div className="about-item">
                        <div className="name">使用须知</div>
                        <span className="about">{currentCard.description}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
              </div>
              )}
            {currentCard.condition_type == 2 && (
              <form onSubmit={this.addPaidCardOrder}>
                <button
                  className="buy-btn"
                  disabled={requesting}
                  onClick={this.addPaidCardOrder}
                  style={convertLineStyleData(
                  'background-color: ' +
                  (currentCard.style_config &&
                  currentCard.style_config.recv_button
                    ? currentCard.style_config.recv_button
                    : '#FF7100')
                  )}
                >
                {userPaidVipCard.vip_id == currentCard.id
                  ? '续费会员'
                  : '立即购买'}
                </button>
              </form>
            )}
      </div>
    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/vip-benefits/VipBenefits.jsx